import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import QR from '../../images/event/MMA.jpg'
import Amplitude from 'src/utils/amplitudeHelper'
import { SIZES } from 'src/styles/theme'

const StyledModal = styled(Modal)`
  .modal-content {
    background: transparent;
    margin: 0 auto;
    border: none;
  }
 
  .modal-header {
    border: none;
    padding: 16px 0px;

    .close {
      color: #fff;
      opacity: 1;
      padding: 16px 0px;
      margin-right: 0;
      font-size: 40px;
      font-weight: 600;
      text-shadow: none;
    }
  }
  .modal-body {
    margin: 0 auto;
    padding: 0;
    img {
      display: block;
      margin: 0 auto;
      width: 100%;
    }
  }

 
  ${SIZES.mobile} {
    .modal-content {
      width: 100%;
    }
  
    .modal-header {
      padding: 0;
    }
    #content-container {
      img {
        width: 100%;
      }
    }
  }
`

export default function CPDModal({ showModal, hideModal }) {
  return (
    <StyledModal backdrop={true} show={showModal} onHide={hideModal} aria-labelledby="game-modal" size="xl" centered>
      <Modal.Header closeButton>
      </Modal.Header>
      <Modal.Body>
        <img src={QR} alt="QR code" />
      </Modal.Body>
    </StyledModal>
  )
}
